import { RetCode } from './contants';

/** 用户是否登录 */
export const userIsLogin = (retCode: number) =>
  ![RetCode.NotLogin, RetCode.UserNotRegister, RetCode.UserNotAudit, RetCode.TestEnvNotWhitePhone].includes(retCode);

/** 供应商是否失效 */
export const isInvalidSupplier = (retCode: number) => retCode === RetCode.SupplierLinkCodeError;
